(window["webpackJsonpmeg_ui"] = window["webpackJsonpmeg_ui"] || []).push([["badge~index"],{

/***/ 157:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./src/utils/vue_types/index.js + 1 modules
var vue_types = __webpack_require__(0);

// EXTERNAL MODULE: external "classnames"
var external_classnames_ = __webpack_require__(2);
var external_classnames_default = /*#__PURE__*/__webpack_require__.n(external_classnames_);

// CONCATENATED MODULE: ./src/components/badge/badge.jsx
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// 组件的样式文件
 // import './style/index.scss';


var prefixCls = 'meg-badge';
/* harmony default export */ var badge = ({
  name: 'MegBadge',
  props: {
    value: vue_types["a" /* default */].oneOfType([vue_types["a" /* default */].string, vue_types["a" /* default */].number]),
    max: vue_types["a" /* default */].oneOfType([vue_types["a" /* default */].string, vue_types["a" /* default */].number]),
    isDot: vue_types["a" /* default */].bool
  },
  computed: {
    content: function content() {
      if (this.isDot) return;
      var value = this.value;
      var max = this.max;

      if (value && max) {
        return Number(max) < Number(value) ? "".concat(max, "+") : value;
      }

      return value;
    },
    classes: function classes() {
      var _ref;

      var isDot = this.isDot,
          color = this.color,
          value = this.value,
          className = this.className;
      console.log('value=====', value);
      return _ref = {}, _defineProperty(_ref, color, color), _defineProperty(_ref, className, className), _defineProperty(_ref, "".concat(prefixCls, "-content"), !!value & !isDot), _defineProperty(_ref, "".concat(prefixCls, "-isdot"), isDot), _defineProperty(_ref, "".concat(prefixCls, "-is-fixed"), this.$slots.default), _ref;
    }
  },
  render: function render() {
    var h = arguments[0];
    var classes = this.classes,
        content = this.content;
    return h("div", {
      "class": 'meg-badge'
    }, [h("div", {
      "class": 'meg-badge-body-center'
    }, [h("div", [this.$slots.default]), h("div", {
      "class": external_classnames_default()(classes)
    }, [content])])]);
  }
});
// CONCATENATED MODULE: ./src/components/badge/index.jsx
 //import MegBadgeGroup from './group';

badge.install = function (Vue) {
  Vue.component(badge.name, badge); //Vue.component(MegBadgeGroup.name, MegBadgeGroup);
};

/* harmony default export */ var components_badge = __webpack_exports__["default"] = (badge);

/***/ })

}]);